import React from 'react';
import { Container, PauseButton } from './Styles';

const BonusTime = ({
                         show,
                         onClick,
                         bgColor,
                         bgVariance,
                         color,
                         icon,
                         isLanePaused,
                         iconOnly,
                         currentAuctionId,
                         auctionLaneId
                     }) => {
    const getButtonText = () => {
        if (iconOnly) return null;
        return !isLanePaused ? 'BONUS TIME ACTIVATED' : 'START E-LANE';
    };

    return (
        <>
            {show && (
                <Container>
                    <PauseButton
                        onClick={() => onClick(currentAuctionId, auctionLaneId)}
                        bgColor={bgColor}
                        color={color}
                        bgVariance={bgVariance}
                    >
                        <i className={`fa ${icon}  fa-2`} aria-hidden="true" />
                        EXTEND
                    </PauseButton>
                </Container>
            )}
        </>
    );
};

export default BonusTime;
